import React from 'react';
import { Text, View } from 'react-native';
import { Card } from 'react-native-paper';
import { capitalize } from '../utils/string';
import { styles } from './ProfileViewStyle';
import { FormCard } from './FormCard';
import { DislikeValuePrefix } from './formValuesModel';
import { FoodCheckboxes } from './FoodCheckboxes';
import pluralize from 'pluralize';
const pluralizeCategory = (category) => {
    const plurals = ['vegetable'];
    return plurals.includes(category) ? pluralize(category) : category;
};
const pluralizeDislike = (foodName) => {
    const plurals = [
        'apple',
        'artichoke',
        'cucumber',
        'grapefruit',
        'onion',
        'orange',
        'tomato',
    ];
    return plurals.includes(foodName) ? pluralize(foodName) : foodName;
};
const formatDislikeLabel = (food) => pluralizeDislike(food.name);
export const DislikesCard = ({ dislikedFoods, dislikeValues, readOnly }) => {
    return (<FormCard>
      <Card.Content>
        <Text style={styles.labelText}>What foods do you dislike? 😝</Text>
        <View>
          {dislikedFoods &&
            Object.entries(dislikedFoods)
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([category, fuds]) => (<View key={category}>
                  <Text style={styles.foodCategoryText}>
                    {capitalize(pluralizeCategory(category))}:
                  </Text>
                  <FoodCheckboxes foods={fuds} valuePrefix={DislikeValuePrefix} values={dislikeValues} readOnly={readOnly} labelTransformer={formatDislikeLabel}/>
                </View>))}
        </View>
      </Card.Content>
    </FormCard>);
};
